mutation DeleteOrganizationUsers($ids: [ID!]!) {
  deleteOrganizationUsers(ids: $ids) {
    id
    deleted
    deletedAt
  }
}

